export type CommanderModuleId =
  | "product_redemptions"
  | "daily_tasks"
  | "ops_tat"
  | "alerts"
  | "alerts_dashboard";

export interface CommanderModuleDef {
  name: string;
  description: string;
}

/**
 * Registry of Commander portal modules tracked in GA4.
 * Add a new entry when instrumenting another dashboard.
 */
export const COMMANDER_MODULES: Record<CommanderModuleId, CommanderModuleDef> = {
  product_redemptions: {
    name: "Product Redemptions",
    description:
      "Coupon journey and product redemption analytics for ops (Individual / Onelink / All)",
  },
  daily_tasks: {
    name: "Daily Tasks",
    description:
      "Ops TAT and open-work queue across Projects, Mockup, File/CDR, PR, PO, inward, and print stages",
  },
  ops_tat: {
    name: "Operations TAT",
    description:
      "Operations turnaround analytics for cycle time, stage TAT, dispatch, and inward deviation",
  },
  alerts: {
    name: "Alerts",
    description:
      "Admin alerts: navbar bell panel, alerts inbox, and alert detail with resolve",
  },
  alerts_dashboard: {
    name: "Alerts Dashboard",
    description:
      "Alerts monitoring: alerts raised, recipients, read rate, admin push and client email deliveries",
  },
};

/**
 * Short GA4 event-name prefixes. Pattern: `{prefix}_{surface}_{action}`.
 * Dashboards bake `db` (= dashboard) into the prefix; alerts pass the surface
 * (`bell` / `inbox` / `dtl`) per event. See `.claude/GA_TRACKING.md`.
 */
export const COMMANDER_EVENT_PREFIX: Record<CommanderModuleId, string> = {
  product_redemptions: "redemp_db",
  /** Pattern: `task_db_{section}_{action}` — section = projects / mockup / file / pr / … */
  daily_tasks: "task_db",
  ops_tat: "ops_tat_db",
  alerts: "alerts",
  alerts_dashboard: "alerts_db",
};
